import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'edenred-ui';
import { useTheme } from 'styled-components';

import { OrderType } from '@epi-constants/orderType';
import { FormFields } from '@epi-forms/helpers';
import { EmailAddressField } from '@epi-forms/controls';
import { AdditionalMessageField } from '@epi-forms/controls/AdditionalMessageField';
import { ForwardInvoiceProps } from '@epi-models/forms/ForwardInvoice';

export function ForwardInvoice({ orderType }: ForwardInvoiceProps) {
  const { t } = useTranslation();
  const { gray10 } = useTheme();

  return (
    <Box border="1px solid" borderColor={gray10} p={2}>
      {t('forms.payment_method.forward_instructions')}
      <br />
      {orderType === OrderType.voucher && (
        <div className="blue-text mb-10">
          {t('forms.payment_method.order_shipped_after_payment')}
        </div>
      )}
      <Box margin="10px 0 20px 0">
        {t('forms.payment_method.email_address')}
        <EmailAddressField fieldName={FormFields.InvoicingEmailAddress} />
      </Box>
      <Box marginBottom="10px">
        {t('forms.payment_method.message')}
        <AdditionalMessageField />
      </Box>
    </Box>
  );
}
